<template>
  <!--
    其它合同： contractSource 2
    驳回合同：contractSource 1  verifyStatus 2
    已审核合同：contractSource 1 verifyStatus 1
    未审核合同：contractSource 1 verifyStatus 0
 -->
  <div>
    <van-popup v-model="showPop" position="right" style="height: 100%; width: 80%" @click-overlay="closePopup">
      <div class="btn-wrap">
        <div class="pop-title">
          <p>搜索筛选区</p>
          <van-icon name="cross" @click="cancel" />
        </div>
      </div>
      <div class="input-wrap">
        <!-- 客户id 银行名称 到账日期  提单已审核专用搜索框 -->
        <van-cell-group>
          <van-field readonly clickable v-model="deptName" @click="showPicker('dept')" label="部门"  placeholder="请选择所在部门" />
          <van-field readonly clickable v-model="serviceTypeName" @click="showPicker('service')" label="业务类型" placeholder="请选择业务类型" />
        </van-cell-group>
      </div>
      <div class="footer-btn-wrap">
        <van-button size="mini" type="primary" class="resetBtn" @click="resetQuery">重置</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="submitForm">搜索</van-button>
        <van-button size="mini" type="info" class="submitbtn" @click="cancel">取消</van-button>
      </div>
    </van-popup>
    <van-popup v-model="tree.typeTree" position="bottom">
      <van-cascader :title="tree.title" :options="tree.treeList" @change="treeChange" :field-names="tree.fieldNames" @close="tree.typeTree = false" @finish="onFinishTree" />
    </van-popup>
    <!-- <van-popup v-model="showServiceTree" position="bottom">
      <van-cascader title="请选择业务类型/请选择所在部门" :options="serviceTypeTreeList" :field-names="fieldNames" @change="serviceChange"  @close="showServiceTree = false" @finish="onFinishTree('serviceType')" />
    </van-popup> -->
  </div>
</template>

<script>
import { Cascader } from 'vant'
import { businessTypeList, CascaderTreeSelect } from '@/api/admi/dept'
export default {
  name: 'ApplySearch',
  props: {
    show: Boolean,
    verifyStatus: [String, Number]
  },
  watch: {
    show: function (newVal, oldVal) { // 不能用箭头函数
      this.showPop = newVal
    },
    verifyStatus: function (newVal, oldVal) {
      this.query.verifyStatus = newVal
    }
  },
  components: {
    vanCascader: Cascader
  },
  data() {
    return {
      showPop: false,
      deptName: '',
      serviceTypeName: '',
      query: {
        pageNum: 1,
        pageSize: 10,
        deptId: '',
        serviceTypeId: '',
        verifyStatus: ''
      },
      deptTreeList: [],
      serviceTypeTreeList: [],
      tree: {
        type: '',
        title: '',
        typeTree: false,
        treeList: [],
        fieldNames: {

        }
      }
      // fieldNames: {
      //   text: 'businessTypeName',
      //   value: 'businessTypeId'
      // }
    }
  },
  async created() {
    this.query.verifyStatus = this.verifyStatus
  },
  mounted() {
  },
  methods: {
    resetQuery() {
      this.query = {
        pageNum: 1,
        pageSize: 10,
        deptId: '',
        serviceTypeId: '',
        serviceTypeName: '',
        verifyStatus: this.verifyStatus
      }
      this.deptName = ''
      this.serviceTypeName = ''
    },
    cancel() {
      this.showPop = false
      this.$emit('update:show', false)
    },
    closePopup() {
      this.showPop = false
      this.$emit('update:show', false)
    },
    formatDate(date) {
      // 时间格式化 2019-09-08
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      return year + '-' + month + '-' + day
    },
    // 去除树形数据的空children
    removeEmptyChildren(node) {
      node.forEach(item => {
        if ('children' in item && item.children.length === 0) {
          delete item.children
        } else if ('children' in item && item.children.length) {
          this.removeEmptyChildren(item.children)
        }
      })
      return node
    },
    /** 转换业务类型数据结构 */
    getData (arr) {
      // 利用两层filter实现
      const data = arr.filter(item => {
        item.children = arr.filter(e => {
          return item.businessTypeId === e.parentId
        })
        return !item.parentId
      })
      return this.removeEmptyChildren(data)
    },
    async showPicker(val) {
      if (val === 'dept') {
        if (this.deptTreeList.length == 0) {
          // 获取部门信息
          await CascaderTreeSelect().then((response) => {
            this.deptTreeList = response.data
          })
        }
        this.tree = {
          type: val,
          title: '请选择所在部门',
          typeTree: true,
          treeList: this.deptTreeList,
          fieldNames: {}
        }
      } else if (val === 'service') {
        if (this.serviceTypeTreeList.length == 0) {
          // 获取获取业务类型
          await businessTypeList({ pageNum: 1, pageSize: 500 }).then((response) => {
            if (response.code === 200) {
              this.serviceTypeTreeList = this.getData(response.rows)
            }
          })
        }
        this.tree = {
          type: val,
          title: '请选择业务类型',
          typeTree: true,
          treeList: this.serviceTypeTreeList,
          fieldNames: {
            text: 'businessTypeName',
            value: 'businessTypeId'
          }
        }
      }
    },
    treeChange(obj) {
      if (this.tree.type === 'dept') {
        this.query.deptId = obj.value
        this.deptName = obj.selectedOptions.map((option) => option.text).join('/')
      }
      console.log(this.query)
    },
    onFinishTree(obj) {
      if (this.tree.type === 'service') {
        this.query.serviceTypeId = obj.value
        this.serviceTypeName = obj.selectedOptions.map((option) => option.businessTypeName).join('/')
      }
      this.tree.typeTree = false
    },
    submitForm() {
      console.log(this.query)
      this.$emit('handlequery', this.query)
    }
  }
}
</script>
<style lang="less">
.btn-wrap {
  width: 100%;
  box-sizing: border-box;

  .pop-title {

    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 36px;
    font-weight: bold;
    padding: 0;
    padding: 0 30px;
  }
  .type-list {
    margin-bottom: 40px;

    .title {
      font-size: 28px;
      font-weight: bold;
    }
    .list-wrapper {
      line-height: 0.5;
    }
  }
  .input-wrap {
    margin-top: 20px;
  }
  .select_list {
    .van-button {
      margin-top: 10px !important;
      margin-bottom: 10px !important;
    }
  }
}
.footer-btn-wrap {
  position: fixed;
  bottom: 100px;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 30px;

  display: flex;
  justify-content: space-around;

  .van-button {
    width: 45%;
    height: 60px;
    font-size: 30px;

    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
}
</style>
